export default __webpack_public_path__ + "src/design/images/bdaccount_certification_icon.png";